import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { removeFittingSize, updateSts } from './fittingSizeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import "./fittingSize.css";
import { isUserAdmin } from '../../services/authenticationService';

export default function FittingSizeList() {
    const dispatch = useDispatch();
    const { setModelChange, messageApi, setEditUser, list_data, setList } = React.useContext(CommonContext) as CommonContextType;
    const FittingSizes = useSelector(
        (state: AppState) => state.FittingSizes
    );
    useEffect(() => {
        setList(FittingSizes.FittingSize)
    }, [FittingSizes]);

    useEffect(() => {
        if (FittingSizes.success_.sts == true) {
            messageApi.open({
                type: 'success',
                content: FittingSizes.success_.data,
            });

            dispatch(updateSts({}));
        } else if (FittingSizes.success_.sts == false) {
            messageApi.open({
                type: 'error',
                content: FittingSizes.success_.data,
            });

            dispatch(updateSts({}));
        }

    }, [FittingSizes])

    const showModal = (record?: any) => {
        if (record.id) {
            setEditUser(record)
            setModelChange(true)
        }
    };
    const handleDelete = (id: number) => {
        dispatch(removeFittingSize(id));

    };
    return (
        <List
            className="demo-loadmore-list"
            itemLayout="horizontal"
            dataSource={list_data}
            renderItem={(item: any, index) => (
                <List.Item key={item.id}
                    actions={isUserAdmin() ?
                        [<EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
                        <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
                            <DeleteOutlined style={{ color: 'red' }} />
                        </Popconfirm>] : []}>

                    <div className='first_class'>
                        <p className='sub_data' style={{ width: '20%' }}><b>ID:</b> {index + 1}</p>
                        <div className='sub_data' style={{ width: '30%' }}><b>Code:</b> {item.size_code} <br /><b>Name:</b> {item.size_name} {/* <br />Body Size: {item?.body_size?.bodysize_value} */}</div>
                        <p className='sub_data_box'>{item?.measure_unit?.unit}</p>
                    </div>
                </List.Item>
            )}
        />
    );
}